module.exports = __webpack_public_path__ + "static/media/72.76fc8750.jpg";